import React, {FC, ReactNode} from 'react';
import {SidePanel} from '@geomatico/geocomponents';
import SlideTransition from './SlideTransition';
import {HORIZONTAL_DISPLACEMENT_PANEL, PANEL_WIDTH} from '../config';


//TYPES
export type PanelProps = {
  children: ReactNode,
  width: number
};

const SlidePanel: FC<PanelProps> = ({children, width}) => {

  return <SlideTransition width={PANEL_WIDTH.searchImages} show={true}>
    <SidePanel isOpen={true} widescreen={true} sx={styles(width).sidePanel}>
      {children}
    </SidePanel>
  </SlideTransition>;
};
export default SlidePanel;

const styles = (width: number) => ({
  sidePanel: {
    '&.MuiDrawer-root': {
      height: '100%',
      top: 0,
      position: 'absolute',
      margin: 0,
      padding: 0
    },
    '& .MuiDrawer-paper': {
      borderRadius: '8px',
      opacity: 1,
      position: 'relative',
      width: width,
      left: HORIZONTAL_DISPLACEMENT_PANEL,
      top: 'calc(28px + 50%)',
      transform: 'translateY(-50%)',
      maxHeight: 'calc(100% - 32px)',
      overflowY: 'auto',
      height: 'auto',
      p: 0,
      m: 0
    }
  }
});

